import axiosInstance from "./api_helper";

const soldeService = {
    search: async ({ clientId, dateMouvementFrom, dateMouvementTo }) => {
        return axiosInstance.get('/api/mouvements/search', {
            params: {
                clientId,
                dateMouvementFrom,
                dateMouvementTo
            }
        });
    },

    searchChantier: async ({ clientId, chantierId, dateMouvementFrom, dateMouvementTo }) => {
        return axiosInstance.get('/api/chantier/mouvements/search', {
            params: {
                clientId,
                chantierId,
                dateMouvementFrom,
                dateMouvementTo
            }
        });
    },

    searchFournisseur: async ({ fournisseurId, dateMouvementFrom, dateMouvementTo }) => {
        return axiosInstance.get('/api/fournisseur/mouvements/search', {
            params: {
                fournisseurId,
                dateMouvementFrom,
                dateMouvementTo
            }
        });
    },
    
    searchCommercial: async ({ commercialId, dateMouvementFrom, dateMouvementTo }) => {
        return axiosInstance.get('/api/commercial/mouvements/search', {
            params: {
                commercialId,
                dateMouvementFrom,
                dateMouvementTo
            }
        });
    }
};
export default soldeService;